export default "data:image/webp;base64,UklGRkAAAABXRUJQVlA4TDQAAAAvJ4AGAAWZgEUGOYR1i6XUEjgIsm0QBjKnmw7jPgQBJBKFtMFWQ6za/wnwy8tncDYlVvwB"